module.exports = "<p>\r\n  deleteagent works!\r\n</p>\r\n"